import styled from 'styled-components';

export const MultiSelectContainer = styled.div`
  .multi-dropdown {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  .selected-filters {
    margin-top: 1rem;
    .filter {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.313em 0;
      svg {
        width: 1rem;
        cursor: pointer;
      }
    }
  }
  .dropdown-content {
    position: absolute;
    z-index: 999;
    min-width: 220px;
    padding: 10px 5px;
    margin-top: 1em;
    background-color: #fff;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    .option {
      input[type='checkbox'] {
        & + svg {
          color: #000000;
          width: 14px;
        }
      }
      .option-label {
        cursor: pointer;
        color: #000000;
      }
    }
    .nib {
      height: 0;
      width: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid #fff;
      content: '';
      display: block;
      position: absolute;
      top: -10px;
      left: 1em;
    }
  }
`;
